import {useEffect, useState} from 'react';
import styles from './ReportView.module.css';
import {IReportAction, TableRow} from "../../types/types.table.ts";
import {postUser} from "../../helper/http.ts";

interface AppBarProps {
  action: IReportAction;
  row: TableRow;
}


export default function ReportView({
    action,
    row
}: AppBarProps) {
    const [page, setPage] = useState(0);
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(true);

    const prepareString = (str: string) => {
        console.log(str, row);
        for (const key in row) {
            str = str.replace('$' + key + '$', row[key] + '');
        }

        return str;
    }

    useEffect(() => {
        console.log(action, row);
        //
    //
    //   const body: any = {
    //       module: action.module,
    //       page: page.toString(),
    //       per_page: "1",
    //       sort_direction: "+",
    //       sort_field: "id",
    //       filters: {},
    //   };
    //
    //   for (let key in action.params) {
    //       body.filters[key] = row[action.params[key]];
    //   }
    //
    //     postUser("crud/list", body).then((res) => {
    //
    //         setData(res.data);
    //
    //         setLoading(false);
    //     });
    //
        setLoading(false);
    }, [page]);

    if (loading) return <div>loading...</div>

        return action.rows.map(actionRow => <div className={styles.reportRow}>
            {actionRow.type === 'label' && prepareString(actionRow.text)}
            {actionRow.type === 'row' && actionRow.cols.map(col => <div className={styles.reportRowCol}>{prepareString(col.text)}</div>)}
        </div>);
}